import { render, staticRenderFns } from "./CompareCards.vue?vue&type=template&id=117df4d4&scoped=true&"
import script from "./CompareCards.vue?vue&type=script&lang=js&"
export * from "./CompareCards.vue?vue&type=script&lang=js&"
import style0 from "./CompareCards.vue?vue&type=style&index=0&id=117df4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117df4d4",
  null
  
)

export default component.exports